import React from 'react';
import PropTypes from 'prop-types';
import Slider, { Range } from 'rc-slider';

const RcSlider = ({ min, max, step, defaultValue, isRange, ...props }) => {
  const setValues = {
    min,
    max,
    step,
    defaultValue
  };

  return isRange ? <Range {...setValues} {...props} /> : <Slider {...setValues} {...props} />;
};

RcSlider.defaultProps = {
  step: null,
  isRange: false
};

RcSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
  isRange: PropTypes.bool
};

export default RcSlider;
